export var SET_UNITY_CONTENT = 'SET_UNITY_CONTENT';
export function setUnityContent(content) {
  return {
    type: SET_UNITY_CONTENT,
    payload: {
      content: content
    }
  };
}